import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
import SimplePagination from "./SimplePagination";
class ReplaceDocumentTemplate extends Component {
    static contextType = LangContext; 
    constructor(props) {
        super(); 
        this.state = { 
            documents:[],  
            documentsToReplace: [],
            selectedDocumentId: null,
            selectedDocumentName:null,
            selectedDocumentToReplaceId: null,
            selectedDocumentToReplaceName: null,
            step: 1,
            search:'',
            page: 1,
            total: 0,
            maxRecords: 10,
        }; 
        this.handleOpenModalReplaceDocument = this.handleOpenModalReplaceDocument.bind(this); 
        this.handleNextStep = this.handleNextStep.bind(this); 
        this.handlePreviousStep = this.handlePreviousStep.bind(this); 
        this.handleReplace = this.handleReplace.bind(this);
    }   
    updateCurrentPage = (page) =>{
        this.setState({page: page}, function () {
            this.getDocuments();
        });
    }
    async getDocuments(){  
        const url = '/api/dossiers/document_templates'; 
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString(); 
        const response = await axios.get(url+`?${qs}`, { 
            params: { 
                level: this.props.level, 
                dossier_id: this.props.dossier_id, 
                person_provider_id: this.props.person_provider_id 
            } 
        });  
        
        const documents = response.data.documents; 
        if(documents.length == 0){
            swal.fire({
                text: "No cuentas con plantillas para reemplazar",
                icon: "info",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            })
        } else {
            $('#replaceDocumentModal').modal('show'); 
            this.setState({ documents: documents });
            this.setState({ documentsToReplace: response.data.documentsToReplace.data });
            this.setState({ total: response.data.documentsToReplace.total });
        } 
    } 

    handleOpenModalReplaceDocument() {   
        this.getDocuments(); 
    }  

    handleNextStep() {
        if(this.state.selectedDocumentId) {
            this.setState({ step: 2 });  
        }
    }

    handlePreviousStep() {
        this.setState({ step: 1, selectedDocumentToReplaceId: null });
    } 

     handleSearchChange = (e)=>{ 
            this.setState({ search: e.target.value}, function () { 
                this.getDocuments();
            }); 
    }

    handleReplace() {
        event.preventDefault(); // Prevent form submission
        event.stopPropagation(); // Stop the event from bubbling up
        if(this.state.selectedDocumentId && this.state.selectedDocumentToReplaceId) {
            let warning ; 
            if(this.props.level == 'dossier_template'){
                warning  = 'Este cambio remplazará la plantilla de documento “'+this.state.selectedDocumentName+'” por “'+this.state.selectedDocumentToReplaceName+'” en todos los expedientes que utilizan esta plantilla de Expediente. <br> <br> ¿Estás seguro que deseas continuar?'      
            }else{
                warning  = '¿Estás seguro que deseas sustituir la plantilla “'+this.state.selectedDocumentName+'” por “'+this.state.selectedDocumentToReplaceName+'”?'
            }
            swal.fire({
                html: warning,
                icon: "question",
                buttonsStyling: false,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Aceptar', 
                reverseButtons: true,
                showCancelButton: true,
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary",
                    cancelButton: "btn font-weight-bold btn-secondary" 
                }
            }).then((result) => { 
                if(result.isConfirmed == true){
                    console.log( this.state.selectedDocumentId) 
                    axios.post('/api/dossiers/replace/documents', {
                        document_id: this.state.selectedDocumentId, 
                        document_to_replace_id: this.state.selectedDocumentToReplaceId,
                        level: this.props.level,
                        dossier_id: this.props.dossier_id, 
                        person_provider_id: this.props.person_provider_id 
                    }).then(response => {
                        swal.fire({
                            text: 'El documento ha sido reemplazado exitosamente',
                            icon: "success",
                            buttonsStyling: false,
                            confirmButtonText: 'Aceptar',
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            },
                            timer: 3000
                        }).then(function(result) { 
                            location.reload();
                        });
                    })
                    .catch(error => { 
                        console.error(error);
                    }); 
                } 
            }); 
        }
    }

    render() { 
        const { documents, documentsToReplace, selectedDocumentId, selectedDocumentToReplaceId, step } = this.state;
        const { lang } = this.context; 
        return (
            <div className="modal fade" id="replaceDocumentModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content" style={{ background: '#f5f5f5' }}>
                        <div className="modal-body px-15 py-10">
                            <h5 className="text-dark font-weight-bold my-1 mr-5">
                                Reemplazar Documentos
                            </h5>
                            {step === 1 && documents.length > 0 &&
                                <>
                                    <div className="text-muted">
                                        Selecciona la plantilla de documento que deseas reemplazar
                                    </div>
                                    <div className="card card-custom gutter-b my-5">  
                                        <div className="card-body pt-5">  
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Seleccionar</th>
                                                        <th>Título</th>
                                                        <th>Frecuencia</th>
                                                        <th>Formatos</th>
                                                        <th>Categoría</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {documents
                                                    .filter(doc => doc.document.version === 1)
                                                    .map((doc, i) => (
                                                        <tr key={i}>
                                                            <td>
                                                                <input 
                                                                    type="radio" 
                                                                    name="document" 
                                                                    value={doc.document.id}
                                                                    checked={selectedDocumentId === doc.document.id}
                                                                    onChange={() => {
                                                                        this.setState({ selectedDocumentId: doc.document.id })
                                                                        this.setState({ selectedDocumentName: doc.document.title })
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{doc.document.title}</td>
                                                            <td>{doc.document.period}</td>
                                                            <td>{doc.document.mimes.map((mime, i, { length }) => (i === length - 1 ? mime.mime.toUpperCase() : mime.mime.toUpperCase() + ', '))}</td>
                                                            <td>{doc.document.type.category.name}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div> 
                                    </div> 
                                    <div className="text-right mb-5">
                                        <button className="btn btn-secondary font-weight-bolder px-10" data-dismiss="modal">Cancelar</button>
                                        <button className="ml-5 btn btn-primary font-weight-bolder px-10" onClick={this.handleNextStep} disabled={!selectedDocumentId}>Siguiente</button>
                                    </div> 
                                </>
                            }
                            {step === 2   &&  
                                <>
                                    <div className="text-muted">
                                        Seleccione la plantilla de documento que reemplazará a la anterior.
                                    </div> 
                                    <div className="card card-custom gutter-b my-5">  
                                    {/**
                                     * 
                                     * <div className="col-4 d-flex ml-auto mt-6">
                                            <div className="input-icon">
                                                <input
                                                    name="search"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Buscar"
                                                    onChange={this.handleSearchChange}
                                                />
                                                <span>
                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                </span>
                                            </div>
                                        </div>
                                     * 
                                     */}
                                        
                                        {step === 2 && documentsToReplace.length > 0 &&
                                            <>
                                            <div className="card card-custom gutter-b my-5">   
                                                <div className="card-body pt-5">  
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Seleccionar</th>
                                                                <th>Título</th>
                                                                <th>Frecuencia</th>
                                                                <th>Formatos</th>
                                                                <th>Categoría</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {documentsToReplace
                                                            .filter(doc => doc.version === 1)
                                                            .map((doc, i) => (
                                                                <tr key={i}>
                                                                    <td>
                                                                        <input 
                                                                            type="radio" 
                                                                            name="documentToReplace" 
                                                                            value={doc.id}
                                                                            checked={selectedDocumentToReplaceId === doc.id}
                                                                            onChange={() => {
                                                                                this.setState({ selectedDocumentToReplaceId: doc.id })
                                                                                this.setState({ selectedDocumentToReplaceName: doc.title })
                                                                                } 
                                                                            }
                                                                        />
                                                                    </td>
                                                                    <td>{doc.title}</td>
                                                                    <td>{doc.period}</td>
                                                                    <td>{doc.mimes.map((mime, i, { length }) => (i === length - 1 ? mime.mime.toUpperCase() : mime.mime.toUpperCase() + ', '))}</td>
                                                                    <td>{doc.type.category.name}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div> 
                                                {this.state.total > this.state.maxRecords  &&
                                                    <SimplePagination
                                                    updateCurrentPage={this.updateCurrentPage}
                                                    currentPage={this.state.page}
                                                    totalFiles={this.state.total}
                                                    split={this.state.maxRecords} />
                                                }
                                            </div> 
                                                <div className="text-right mb-5">
                                                    <button className="btn btn-secondary font-weight-bolder px-10" onClick={this.handlePreviousStep}>Atrás</button>
                                                    <button className="ml-5 btn btn-primary font-weight-bolder px-10" onClick={this.handleReplace} disabled={!selectedDocumentToReplaceId}>Reemplazar</button>
                                                </div> 
                                            </>
                                        } 
                                        {step === 2 && documentsToReplace.length == 0 &&
                                            <div className="text-center p-10">
                                                No se encontraron plantillas
                                            </div>
                                        }
                                    </div>
                                </>
                            }
                            
                        </div> 
                    </div>
                </div>
            </div>
        );
    }
}

export default ReplaceDocumentTemplate;

if (document.getElementById('ReplaceDocumentTemplate')) {
    ReactDOM.render(<ReplaceDocumentTemplate />, document.getElementById('ReplaceDocumentTemplate'));
}
